import { Box } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';

function Page({ title, children, ...rest }) {
  return (
    <Box {...rest}>
      <Helmet>
        <title>{title} | X-Lance</title>
      </Helmet>
      {children}
    </Box>
  );
}

export default Page;
